export const AUTH_STORAGE_KEYS = {
  accessToken: "okta_access_token",
  idToken: "okta_id_token",
  tokenExpiresAt: "okta_token_expires_at",
  user: "okta_user",
  /** JSON snapshot of `effective_access` from last successful /auth/okta/verify. */
  effectiveAccess: "okta_effective_access",
} as const;

/** Aligns with backend `AUTH_MODE` (`okta` | `disabled`). */
export type ClientAuthMode = "okta" | "disabled";

function parseClientAuthMode(raw: string | undefined): ClientAuthMode | undefined {
  if (raw === "okta" || raw === "disabled") {
    return raw;
  }
  return undefined;
}

/** When `VITE_AUTH_MODE` is set to a known value, mirrors backend auth mode for docs/tooling. */
export const authMode: ClientAuthMode | undefined = parseClientAuthMode(import.meta.env.VITE_AUTH_MODE);

export const oktaConfig = {
  issuer: import.meta.env.VITE_OKTA_ISSUER ?? "",
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID ?? "",
  /** Must match Okta app Sign-in redirect URIs and the same value used in `/v1/authorize` and `/v1/token`. */
  redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI ?? `${window.location.origin}/okta-callback`,
  scopes: import.meta.env.VITE_OKTA_SCOPES ?? "openid profile email",
} as const;
